import __request__ from 'routing/request';
interface RemoteReindexIndex {
    readonly took: string;
    readonly error_msg: string;
    readonly created: string;
    readonly name: string;
    readonly progress: IndexMigrationProgress;
    readonly status: 'NOT_STARTED' | 'STARTING' | 'RUNNING' | 'ERROR' | 'FINISHED';
}
interface RemoteReindexParams {
    readonly allowlist: string;
    readonly hostname: string;
    readonly password: string;
    readonly indices: string[];
    readonly synchronous: boolean;
    readonly threads_count: number;
    readonly user: string;
}
interface IndexMigrationProgress {
    readonly total: number;
    readonly deleted: number;
    readonly created: number;
    readonly updated: number;
}
interface RemoteReindexMigration {
    readonly indices: RemoteReindexIndex[];
    readonly progress: number;
    readonly id: string;
    readonly error: string;
    readonly logs: LogEntry[];
    readonly tasks_progress: {
        readonly [_key: string]: number;
    };
    readonly status: 'NOT_STARTED' | 'STARTING' | 'RUNNING' | 'ERROR' | 'FINISHED';
}
interface LogEntry {
    readonly log_level: 'INFO' | 'WARN' | 'ERROR';
    readonly message: string;
    readonly timestamp: string;
}
/**
 * by remote reindexing
 */
export function migrate(remoteconfiguration?: RemoteReindexParams): Promise<string> {
    return __request__('POST', '/remote-reindex-migration/remoteReindex', remoteconfiguration, {}, {
        'Accept': ['application/json']
    });
}
/**
 * status
 */
export function status(migrationID?: string): Promise<RemoteReindexMigration> {
    return __request__('GET', `/remote-reindex-migration/status/${migrationID}`, null, {}, {
        'Accept': ['application/json']
    });
}
